// extracted by mini-css-extract-plugin
module.exports = {"container":"_1aug9YbuR1q2setjStzEYA","row":"_1qWah509KJgGQ8022gTbua","subTitle":"_2jOZaDXWll-FDjz_rxO6rL","resultNotification":"jMxnG1Bjofz5f76l8uWgl"};